export const onClickAnchor = (id: string) => {
  const block: null | HTMLElement = document.getElementById(id)
  const header: null | HTMLElement = document.getElementById('page-header')
  if (block) {
    const rect = block.getBoundingClientRect()
    window.scrollTo(window.pageXOffset, window.pageYOffset + rect.top - (header?.clientHeight || 0))
  }
}
